export default {
    zh: {
        // SEO Meta
        pageTitle: 'Dreamina 3.0 视频生成器 - 精确的摄像机控制和开始/结束帧指导生成电影级视频 | 微鲤AI',
        pageDescription: 'Dreamina 3.0（即梦 3.0）是字节跳动推出的旗舰级 AI 视频模型，支持首尾帧精确控制、专业电影级运镜和 1080P 高动态视频生成。在 微鲤AI 免费体验即梦 3.0。',
        pageKeywords: 'Dreamina 3.0, 即梦3.0, AI视频生成, 首尾帧控制, 电影级运镜, 字节跳动, 微鲤AI',

        // 生成器部分
        generatorTitle: '即梦 3.0 视频生成器',
        generatorDescription: '即梦视频 3.0 模型是字节跳动（ByteDance）推出的最新一代旗舰级 AI 视频模型，代表了当前视频生成技术的顶尖水平。作为 Dreamina 创意套件的核心升级，该模型引入了革命性的"首尾帧控制"技术和专业电影级运镜系统，能够生成分辨率高达 1080P 的高动态视频。它不仅大幅提升了大幅度动作的稳定性，更通过精准的物理规律模拟，让创作者能够轻松掌控复杂的叙事节奏。快来 微鲤AI 体验即梦 3.0，用一张图或一段文字导演您的视觉大片！',

        // 标签页
        tabImageToVideo: '图片生成视频',
        tabTextToVideo: '文本生成视频',

        // 核心功能部分
        coreFeaturesTitle: 'Dreamina 3.0 核心功能特性',

        // 功能特点
        feature1Title: '首尾帧精确控制',
        feature1Description: '这是 Video 3.0 的杀手级功能。用户不仅可以上传一张图片作为视频的开始（首帧），还可以上传另一张图片作为结束（尾帧）。模型会自动计算中间的过渡动画，确保视频完美地从一个状态演变到另一个状态。这对于制作变身特效、时间流逝或精准的转场镜头至关重要。',
        feature2Title: '专业电影级运镜',
        feature2Description: '基于全新的 PixelDance 底层技术，该模型支持丰富的镜头语言，包括推拉（Zoom）、平移（Pan）、环绕（Orbit）以及低角度仰拍等。相比前代，其运镜更加平滑自然，能够模拟真实摄影师的手持感或轨道拍摄效果，极大地增强了视频的沉浸感。',
        feature3Title: '高动态动作一致性',
        feature3Description: '解决了传统AI视频在生成大幅度动作（如跳舞、奔跑、打斗）时容易导致人物肢体崩坏的问题。Jimeng Video 3.0 增强了对人体骨骼和物理运动规律的理解，即使在剧烈运动中也能保持角色面部和肢体特征的稳定与统一。',
        feature4Title: '多镜头风格统一',
        feature4Description: '专为长视频创作者设计，模型能够理解并记忆特定的美术风格。在生成一系列分镜时，它能确保不同镜头间的光影色调、人物造型和环境氛围保持高度一致，只需一张参考图即可扩展出整部短剧的视觉素材。',

        // 如何使用部分
        howToUseTitle: '如何在 微鲤AI 上使用即梦 3.0 视频生成器',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Dreamina 3.0 或 Dreamina 3.0 Pro 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传一张图片作为"首帧"',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: '关于 Dreamina 3.0 视频模型的精彩介绍',

        // X Posts 部分
        xPostsTitle: '关于 Dreamina 3.0 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索 微鲤AI 上的其他视频模型',

        // FAQ 部分
        faqTitle: '常见问题',
        faq1Question: 'Dreamina 3.0 视频模型和 Dreamina 是什么关系？',
        faq1Answer: 'Dreamina 是字节跳动推出的AI创意平台（国内版名为"即梦"），而 Dreamina 3.0 视频模型是该平台搭载的最新一代视频生成模型。在 微鲤AI 上，我们直接为您接入了这一核心模型能力。',
        faq2Question: '"首尾帧控制"有什么实际用途？',
        faq2Answer: '它能让您精确控制视频的走向。例如，您可以上传一张"闭眼"图做首帧，一张"睁眼"图做尾帧，模型就会生成自然的睁眼过程。这在制作特定剧情或平滑转场时非常有用。',
        faq3Question: '生成的视频清晰度如何？',
        faq3Answer: 'Dreamina 3.0 视频模型支持生成 720P 及 1080P 分辨率的视频，具有极高的清晰度和纹理细节，足以满足社交媒体发布甚至部分商业广告的需求。',
        faq4Question: '在 微鲤AI 上使用是免费的吗？',
        faq4Answer: '微鲤AI 提供新用户免费积分，您可以使用这些积分体验 Dreamina 3.0 视频模型。由于视频生成算力消耗较大，生成一次可能会消耗比图片更多的积分，建议升级会员以获取更多创作额度。',
        faq5Question: '它支持生成多长的视频？',
        faq5Answer: '目前标准单次生成时长为 5 秒和 10 秒。但您可以使用"视频延长（Extend Video）"功能，基于生成的视频继续向后续写，从而获得更长的片段。',
        faq6Question: '它能理解复杂的中文提示词吗？',
        faq6Answer: '是的，作为字节跳动开发模型，Dreamina 3.0 视频模型对中文语境的理解非常深刻，能够精准还原成语、古诗词意境以及复杂的东方审美描述。',

        // CTA 部分
        ctaTitle: '立即体验 Dreamina 3.0',
        ctaDescription: '在 微鲤AI 上免费开始创作电影级 AI 视频',
        ctaButton: '开始生成视频',
        ctaDisclaimer: '无需信用卡，注册即可使用',
    },
    en: {
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
    },
    ja: {
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI動画ジェネレーター - シネマティックカメラ制御 | 微鲤AI',
        pageDescription: 'Dreamina 3.0（即梦 3.0）はバイトダンスのフラッグシップAI動画モデルで、正確な開始/終了フレーム制御、プロフェッショナルなシネマティックカメラ、1080P高ダイナミック動画生成をサポート。WeryAIで無料体験。',
        pageKeywords: 'Dreamina 3.0, 即梦3.0, AI動画生成, 開始終了フレーム制御, シネマティックカメラ, バイトダンス, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 動画ジェネレーター',
        generatorDescription: '即梦Video 3.0はバイトダンスの最新フラッグシップAI動画モデルで、現在の動画生成技術の頂点を表しています。Dreaminaクリエイティブスイートのコアアップグレードとして、革新的な「開始/終了フレーム制御」技術とプロフェッショナルなシネマティックカメラシステムを導入し、最大1080P解像度の高ダイナミック動画を生成できます。大規模な動きの安定性を大幅に向上させ、精密な物理シミュレーションを通じてクリエイターが複雑なナラティブリズムを簡単に制御できるようにします。WeryAIでDreamina 3.0を体験し、1枚の画像またはテキストでビジュアル傑作を監督しましょう！',

        // Tabs
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 コア機能',

        // Features
        feature1Title: '正確な開始/終了フレーム制御',
        feature1Description: 'これはVideo 3.0のキラー機能です。ユーザーは動画の開始（最初のフレーム）として画像をアップロードするだけでなく、終了（最後のフレーム）として別の画像もアップロードできます。モデルは自動的に中間のトランジションアニメーションを計算し、動画が一つの状態から別の状態へ完璧に進化することを保証します。',
        feature2Title: 'プロフェッショナルなシネマティックカメラ',
        feature2Description: '新しいPixelDance基盤技術に基づき、このモデルはズーム、パン、オービット、ローアングルショットなど豊富なカメラ言語をサポートしています。前世代と比較して、カメラの動きはより滑らかで自然になり、実際の撮影監督のハンドヘルド感やトラック撮影効果をシミュレートできます。',
        feature3Title: '高ダイナミックモーション一貫性',
        feature3Description: '従来のAI動画がダンス、ランニング、ファイトなどの大規模な動きを生成する際にキャラクターの手足が崩壊する問題を解決します。即梦Video 3.0は人体の骨格構造と物理的な動きの法則の理解を強化し、激しい動きでもキャラクターの顔と手足の特徴を安定して統一された状態に保ちます。',
        feature4Title: 'マルチショットスタイル一貫性',
        feature4Description: '長編動画クリエイター向けに特別に設計されており、モデルは特定のアートスタイルを理解し記憶できます。一連のストーリーボードを生成する際、異なるショット間でライティングトーン、キャラクターデザイン、環境の雰囲気が高度に一貫していることを保証します。',

        // How to use section
        howToUseTitle: 'WeryAIでDreamina 3.0を使用する方法',
        step1Title: 'モデルを選択',
        step1Description: 'AI動画ツールでDreamina 3.0またはDreamina 3.0 Proモデルを選択',
        step2Title: 'コンテンツを入力',
        step2Description: 'プロンプトを入力するか、「最初のフレーム」として画像をアップロード',
        step3Title: '動画を生成',
        step3Description: '生成ボタンをクリックし、待機して動画をダウンロード',

        // YouTube videos section
        youtubeTitle: 'Dreamina 3.0に関する素晴らしい動画紹介',

        // X Posts section
        xPostsTitle: 'Dreamina 3.0に関する人気のXポスト',

        // Explore other models section
        exploreModelsTitle: 'WeryAI上の他の動画モデルを探索',

        // FAQ section
        faqTitle: 'よくある質問',
        faq1Question: 'Dreamina 3.0動画モデルとDreaminaの関係は？',
        faq1Answer: 'Dreaminaはバイトダンスが立ち上げたAIクリエイティブプラットフォーム（中国では「即梦」として知られる）であり、Dreamina 3.0動画モデルはこのプラットフォームの最新世代動画生成モデルです。WeryAIでは、このコアモデル機能に直接アクセスできます。',
        faq2Question: '「開始/終了フレーム制御」の実用的な用途は？',
        faq2Answer: '動画の方向を正確に制御できます。例えば、「目を閉じた」画像を最初のフレームとして、「目を開けた」画像を最後のフレームとしてアップロードすると、モデルは自然な目を開けるプロセスを生成します。',
        faq3Question: '生成される動画の解像度は？',
        faq3Answer: 'Dreamina 3.0動画モデルは720Pおよび1080P解像度の動画生成をサポートしており、非常に高い鮮明度とテクスチャディテールを持ち、ソーシャルメディア公開や一部の商業広告ニーズに十分対応できます。',
        faq4Question: 'WeryAIでの使用は無料ですか？',
        faq4Answer: 'WeryAIは新規ユーザーに無料クレジットを提供しており、Dreamina 3.0動画モデルを体験できます。動画生成には大きな計算能力が必要なため、1回の生成は画像よりも多くのクレジットを消費する場合があります。',
        faq5Question: 'どのくらいの長さの動画を生成できますか？',
        faq5Answer: '現在、標準的な単一生成時間は5秒と10秒です。ただし、「動画延長」機能を使用して、生成された動画に基づいて延長し、より長いクリップを取得できます。',
        faq6Question: '複雑な中国語プロンプトを理解できますか？',
        faq6Answer: 'はい、バイトダンスが開発したモデルとして、Dreamina 3.0動画モデルは中国語の文脈を深く理解しており、慣用句、古典詩のイメージ、複雑な東洋の美的記述を正確に再現できます。',

        // CTA section
        ctaTitle: '今すぐDreamina 3.0を体験',
        ctaDescription: 'WeryAIで無料でシネマティックAI動画を作成開始',
        ctaButton: '動画生成を開始',
        ctaDisclaimer: 'クレジットカード不要、登録して使用',
    },
    ko: {
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI 동영상 생성기 - 시네마틱 카메라 제어 | 微鲤AI',
        pageDescription: 'Dreamina 3.0(즉몽 3.0)은 바이트댄스의 플래그십 AI 동영상 모델로, 정확한 시작/끝 프레임 제어, 전문적인 시네마틱 카메라, 1080P 고역동 동영상 생성을 지원합니다. WeryAI에서 무료 체험하세요.',
        pageKeywords: 'Dreamina 3.0, 즉몽3.0, AI 동영상 생성, 시작끝프레임제어, 시네마틱 카메라, 바이트댄스, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 동영상 생성기',
        generatorDescription: '즉몽 Video 3.0은 바이트댄스의 최신 플래그십 AI 동영상 모델로, 현재 동영상 생성 기술의 정점을 대표합니다. Dreamina 크리에이티브 스위트의 핵심 업그레이드로서, 혁신적인 "시작/끝 프레임 제어" 기술과 전문적인 시네마틱 카메라 시스템을 도입하여 최대 1080P 해상도의 고역동 동영상을 생성할 수 있습니다. WeryAI에서 Dreamina 3.0을 체험하고 이미지나 텍스트로 비주얼 걸작을 연출하세요!',

        // Tabs
        tabImageToVideo: '이미지에서 동영상',
        tabTextToVideo: '텍스트에서 동영상',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 핵심 기능',

        // Features
        feature1Title: '정확한 시작/끝 프레임 제어',
        feature1Description: '이것은 Video 3.0의 킬러 기능입니다. 사용자는 동영상의 시작(첫 번째 프레임)으로 이미지를 업로드할 수 있을 뿐만 아니라 끝(마지막 프레임)으로 다른 이미지도 업로드할 수 있습니다. 모델은 자동으로 중간 전환 애니메이션을 계산하여 동영상이 한 상태에서 다른 상태로 완벽하게 진화하도록 보장합니다.',
        feature2Title: '전문적인 시네마틱 카메라',
        feature2Description: '새로운 PixelDance 기반 기술을 기반으로, 이 모델은 줌, 팬, 오빗, 로우앵글 샷 등 풍부한 카메라 언어를 지원합니다. 이전 세대와 비교하여 카메라 움직임이 더 부드럽고 자연스러워져 실제 촬영 감독의 핸드헬드 느낌이나 트랙 촬영 효과를 시뮬레이션할 수 있습니다.',
        feature3Title: '고역동 모션 일관성',
        feature3Description: '춤, 달리기, 싸움과 같은 대규모 동작을 생성할 때 캐릭터 팔다리가 붕괴되는 기존 AI 동영상의 문제를 해결합니다. 즉몽 Video 3.0은 인체 골격 구조와 물리적 움직임 법칙에 대한 이해를 강화하여 격렬한 움직임에서도 캐릭터의 얼굴과 팔다리 특징을 안정적이고 통일되게 유지합니다.',
        feature4Title: '멀티샷 스타일 일관성',
        feature4Description: '장편 동영상 제작자를 위해 특별히 설계되었으며, 모델은 특정 예술 스타일을 이해하고 기억할 수 있습니다. 일련의 스토리보드를 생성할 때 다른 샷 간의 조명 톤, 캐릭터 디자인, 환경 분위기가 높은 일관성을 유지하도록 보장합니다.',

        // How to use section
        howToUseTitle: 'WeryAI에서 Dreamina 3.0 사용 방법',
        step1Title: '모델 선택',
        step1Description: 'AI 동영상 도구에서 Dreamina 3.0 또는 Dreamina 3.0 Pro 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트를 입력하거나 "첫 번째 프레임"으로 이미지 업로드',
        step3Title: '동영상 생성',
        step3Description: '생성 버튼을 클릭하고 기다린 후 동영상 다운로드',

        // YouTube videos section
        youtubeTitle: 'Dreamina 3.0에 대한 흥미진진한 동영상 소개',

        // X Posts section
        xPostsTitle: 'Dreamina 3.0에 대한 인기 X 게시물',

        // Explore other models section
        exploreModelsTitle: 'WeryAI의 다른 동영상 모델 탐색',

        // FAQ section
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Dreamina 3.0 동영상 모델과 Dreamina의 관계는?',
        faq1Answer: 'Dreamina는 바이트댄스가 출시한 AI 크리에이티브 플랫폼(중국에서는 "즉몽"으로 알려짐)이며, Dreamina 3.0 동영상 모델은 이 플랫폼의 최신 세대 동영상 생성 모델입니다. WeryAI에서는 이 핵심 모델 기능에 직접 액세스할 수 있습니다.',
        faq2Question: '"시작/끝 프레임 제어"의 실용적인 용도는?',
        faq2Answer: '동영상의 방향을 정확하게 제어할 수 있습니다. 예를 들어, "눈 감은" 이미지를 첫 번째 프레임으로, "눈 뜬" 이미지를 마지막 프레임으로 업로드하면 모델이 자연스러운 눈 뜨는 과정을 생성합니다.',
        faq3Question: '생성되는 동영상의 해상도는?',
        faq3Answer: 'Dreamina 3.0 동영상 모델은 720P 및 1080P 해상도 동영상 생성을 지원하며, 매우 높은 선명도와 텍스처 디테일을 가지고 있어 소셜 미디어 게시 및 일부 상업 광고 요구에 충분합니다.',
        faq4Question: 'WeryAI에서 무료로 사용할 수 있나요?',
        faq4Answer: 'WeryAI는 신규 사용자에게 무료 크레딧을 제공하며, Dreamina 3.0 동영상 모델을 체험할 수 있습니다. 동영상 생성에는 상당한 컴퓨팅 파워가 필요하므로 한 번 생성하면 이미지보다 더 많은 크레딧이 소비될 수 있습니다.',
        faq5Question: '얼마나 긴 동영상을 생성할 수 있나요?',
        faq5Answer: '현재 표준 단일 생성 시간은 5초와 10초입니다. 그러나 "동영상 연장" 기능을 사용하여 생성된 동영상을 기반으로 계속 연장하여 더 긴 클립을 얻을 수 있습니다.',
        faq6Question: '복잡한 중국어 프롬프트를 이해할 수 있나요?',
        faq6Answer: '예, 바이트댄스가 개발한 모델로서 Dreamina 3.0 동영상 모델은 중국어 맥락을 깊이 이해하며, 관용구, 고전 시 이미지, 복잡한 동양 미학 설명을 정확하게 재현할 수 있습니다.',

        // CTA section
        ctaTitle: '지금 Dreamina 3.0 체험하기',
        ctaDescription: 'WeryAI에서 무료로 시네마틱 AI 동영상 제작 시작',
        ctaButton: '동영상 생성 시작',
        ctaDisclaimer: '신용카드 불필요, 등록하여 사용',
    },
    tw: {

        // SEO Meta
        pageTitle: 'Dreamina 3.0 视频生成器 - 精确的摄像机控制和开始/结束帧指导生成电影级视频 | 微鲤AI',
        pageDescription: 'Dreamina 3.0（即梦 3.0）是字节跳动推出的旗舰级 AI 视频模型，支持首尾帧精确控制、专业电影级运镜和 1080P 高动态视频生成。在 微鲤AI 免费体验即梦 3.0。',
        pageKeywords: 'Dreamina 3.0, 即梦3.0, AI视频生成, 首尾帧控制, 电影级运镜, 字节跳动, 微鲤AI',

        // 生成器部分
        generatorTitle: '即梦 3.0 视频生成器',
        generatorDescription: '即梦视频 3.0 模型是字节跳动（ByteDance）推出的最新一代旗舰级 AI 视频模型，代表了当前视频生成技术的顶尖水平。作为 Dreamina 创意套件的核心升级，该模型引入了革命性的"首尾帧控制"技术和专业电影级运镜系统，能够生成分辨率高达 1080P 的高动态视频。它不仅大幅提升了大幅度动作的稳定性，更通过精准的物理规律模拟，让创作者能够轻松掌控复杂的叙事节奏。快来 微鲤AI 体验即梦 3.0，用一张图或一段文字导演您的视觉大片！',

        // 标签页
        tabImageToVideo: '图片生成视频',
        tabTextToVideo: '文本生成视频',

        // 核心功能部分
        coreFeaturesTitle: 'Dreamina 3.0 核心功能特性',

        // 功能特点
        feature1Title: '首尾帧精确控制',
        feature1Description: '这是 Video 3.0 的杀手级功能。用户不仅可以上传一张图片作为视频的开始（首帧），还可以上传另一张图片作为结束（尾帧）。模型会自动计算中间的过渡动画，确保视频完美地从一个状态演变到另一个状态。这对于制作变身特效、时间流逝或精准的转场镜头至关重要。',
        feature2Title: '专业电影级运镜',
        feature2Description: '基于全新的 PixelDance 底层技术，该模型支持丰富的镜头语言，包括推拉（Zoom）、平移（Pan）、环绕（Orbit）以及低角度仰拍等。相比前代，其运镜更加平滑自然，能够模拟真实摄影师的手持感或轨道拍摄效果，极大地增强了视频的沉浸感。',
        feature3Title: '高动态动作一致性',
        feature3Description: '解决了传统AI视频在生成大幅度动作（如跳舞、奔跑、打斗）时容易导致人物肢体崩坏的问题。Jimeng Video 3.0 增强了对人体骨骼和物理运动规律的理解，即使在剧烈运动中也能保持角色面部和肢体特征的稳定与统一。',
        feature4Title: '多镜头风格统一',
        feature4Description: '专为长视频创作者设计，模型能够理解并记忆特定的美术风格。在生成一系列分镜时，它能确保不同镜头间的光影色调、人物造型和环境氛围保持高度一致，只需一张参考图即可扩展出整部短剧的视觉素材。',

        // 如何使用部分
        howToUseTitle: '如何在 微鲤AI 上使用即梦 3.0 视频生成器',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Dreamina 3.0 或 Dreamina 3.0 Pro 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传一张图片作为"首帧"',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: '关于 Dreamina 3.0 视频模型的精彩介绍',

        // X Posts 部分
        xPostsTitle: '关于 Dreamina 3.0 视频模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索 微鲤AI 上的其他视频模型',

        // FAQ 部分
        faqTitle: '常见问题',
        faq1Question: 'Dreamina 3.0 视频模型和 Dreamina 是什么关系？',
        faq1Answer: 'Dreamina 是字节跳动推出的AI创意平台（国内版名为"即梦"），而 Dreamina 3.0 视频模型是该平台搭载的最新一代视频生成模型。在 微鲤AI 上，我们直接为您接入了这一核心模型能力。',
        faq2Question: '"首尾帧控制"有什么实际用途？',
        faq2Answer: '它能让您精确控制视频的走向。例如，您可以上传一张"闭眼"图做首帧，一张"睁眼"图做尾帧，模型就会生成自然的睁眼过程。这在制作特定剧情或平滑转场时非常有用。',
        faq3Question: '生成的视频清晰度如何？',
        faq3Answer: 'Dreamina 3.0 视频模型支持生成 720P 及 1080P 分辨率的视频，具有极高的清晰度和纹理细节，足以满足社交媒体发布甚至部分商业广告的需求。',
        faq4Question: '在 微鲤AI 上使用是免费的吗？',
        faq4Answer: '微鲤AI 提供新用户免费积分，您可以使用这些积分体验 Dreamina 3.0 视频模型。由于视频生成算力消耗较大，生成一次可能会消耗比图片更多的积分，建议升级会员以获取更多创作额度。',
        faq5Question: '它支持生成多长的视频？',
        faq5Answer: '目前标准单次生成时长为 5 秒和 10 秒。但您可以使用"视频延长（Extend Video）"功能，基于生成的视频继续向后续写，从而获得更长的片段。',
        faq6Question: '它能理解复杂的中文提示词吗？',
        faq6Answer: '是的，作为字节跳动开发模型，Dreamina 3.0 视频模型对中文语境的理解非常深刻，能够精准还原成语、古诗词意境以及复杂的东方审美描述。',

        // CTA 部分
        ctaTitle: '立即体验 Dreamina 3.0',
        ctaDescription: '在 微鲤AI 上免费开始创作电影级 AI 视频',
        ctaButton: '开始生成视频',
        ctaDisclaimer: '无需信用卡，注册即可使用',
    },
    pl: {

        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
    },
    es: {
        // SEO Meta
        pageTitle: 'Generador de Videos AI Dreamina 3.0 - Control de Cámara Cinematográfico | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) es el modelo de video AI insignia de ByteDance con control preciso de fotogramas de inicio/fin, movimientos de cámara cinematográficos profesionales y generación de video de alta dinámica en 1080P. Experimenta Dreamina 3.0 gratis en 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, generación de video AI, control de fotogramas, cámara cinematográfica, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Generador de Videos Dreamina 3.0',
        generatorDescription: 'Jimeng Video 3.0 es el último modelo de video AI insignia de ByteDance, representando la cúspide de la tecnología actual de generación de video. Como actualización central del conjunto creativo Dreamina, este modelo introduce la revolucionaria tecnología de "control de fotogramas de inicio/fin" y un sistema de cámara cinematográfico profesional. ¡Ven a 微鲤AI y experimenta Dreamina 3.0!',

        // Tabs
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Core features section
        coreFeaturesTitle: 'Características Principales de Dreamina 3.0',

        // Features
        feature1Title: 'Control Preciso de Fotogramas Inicio/Fin',
        feature1Description: 'Esta es la característica estrella de Video 3.0. Los usuarios pueden subir una imagen como inicio del video (primer fotograma) y otra como final (último fotograma). El modelo calcula automáticamente la animación de transición intermedia.',
        feature2Title: 'Movimiento de Cámara Cinematográfico Profesional',
        feature2Description: 'Basado en la nueva tecnología PixelDance, este modelo soporta un rico lenguaje de cámara, incluyendo Zoom, Pan, Órbita y tomas de ángulo bajo.',
        feature3Title: 'Consistencia de Movimiento de Alta Dinámica',
        feature3Description: 'Resuelve el problema de los videos AI tradicionales que causan colapso de extremidades al generar movimientos a gran escala como bailar, correr o pelear.',
        feature4Title: 'Consistencia de Estilo Multi-Toma',
        feature4Description: 'Diseñado específicamente para creadores de videos largos, el modelo puede entender y recordar estilos artísticos específicos.',

        // How to use section
        howToUseTitle: 'Cómo Usar Dreamina 3.0 en 微鲤AI',
        step1Title: 'Seleccionar Modelo',
        step1Description: 'Selecciona el modelo Dreamina 3.0 o Dreamina 3.0 Pro en las herramientas de video AI',
        step2Title: 'Ingresar Contenido',
        step2Description: 'Ingresa un prompt o sube una imagen como "primer fotograma"',
        step3Title: 'Generar Video',
        step3Description: 'Haz clic en el botón generar, espera y descarga tu video',

        // YouTube videos section
        youtubeTitle: 'Emocionantes Introducciones en Video sobre Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Publicaciones Populares en X sobre Dreamina 3.0',

        // Explore other models section
        exploreModelsTitle: 'Explora Otros Modelos de Video en 微鲤AI',

        // FAQ section
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Cuál es la relación entre Dreamina 3.0 y Dreamina?',
        faq1Answer: 'Dreamina es una plataforma creativa AI lanzada por ByteDance, mientras que Dreamina 3.0 es el modelo de generación de video de última generación en esta plataforma.',
        faq2Question: '¿Cuáles son los usos prácticos del "control de fotogramas inicio/fin"?',
        faq2Answer: 'Te permite controlar con precisión la dirección de tu video. Por ejemplo, puedes subir una imagen de "ojos cerrados" como primer fotograma y una de "ojos abiertos" como último.',
        faq3Question: '¿Cuál es la resolución de los videos generados?',
        faq3Answer: 'Dreamina 3.0 soporta generación de videos en resolución 720P y 1080P.',
        faq4Question: '¿Es gratis usar en 微鲤AI?',
        faq4Answer: '微鲤AI proporciona créditos gratuitos para nuevos usuarios para experimentar Dreamina 3.0.',
        faq5Question: '¿Qué duración de videos puede generar?',
        faq5Answer: 'Actualmente, la duración estándar de generación única es de 5 y 10 segundos. Puedes usar la función "Extender Video" para clips más largos.',
        faq6Question: '¿Puede entender prompts complejos en chino?',
        faq6Answer: 'Sí, como modelo desarrollado por ByteDance, Dreamina 3.0 tiene una comprensión profunda del contexto chino.',

        // CTA section
        ctaTitle: 'Experimenta Dreamina 3.0 Ahora',
        ctaDescription: 'Comienza a crear videos AI cinematográficos gratis en 微鲤AI',
        ctaButton: 'Comenzar a Generar Videos',
        ctaDisclaimer: 'No se requiere tarjeta de crédito, regístrate para usar',
    },
    fr: {
        // SEO Meta
        pageTitle: 'Générateur de Vidéos AI Dreamina 3.0 - Contrôle de Caméra Cinématographique | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) est le modèle vidéo AI phare de ByteDance avec contrôle précis des images de début/fin, mouvements de caméra cinématographiques professionnels et génération vidéo haute dynamique 1080P.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, génération vidéo AI, contrôle d\'images, caméra cinématographique, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Générateur de Vidéos Dreamina 3.0',
        generatorDescription: 'Jimeng Video 3.0 est le dernier modèle vidéo AI phare de ByteDance, représentant le sommet de la technologie actuelle de génération vidéo. Venez sur 微鲤AI et expérimentez Dreamina 3.0!',

        // Tabs
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Core features section
        coreFeaturesTitle: 'Caractéristiques Principales de Dreamina 3.0',

        // Features
        feature1Title: 'Contrôle Précis des Images Début/Fin',
        feature1Description: 'C\'est la fonctionnalité phare de Video 3.0. Les utilisateurs peuvent télécharger une image comme début de vidéo et une autre comme fin. Le modèle calcule automatiquement l\'animation de transition intermédiaire.',
        feature2Title: 'Mouvement de Caméra Cinématographique Professionnel',
        feature2Description: 'Basé sur la nouvelle technologie PixelDance, ce modèle prend en charge un riche langage de caméra, incluant Zoom, Pan, Orbite et prises de vue en contre-plongée.',
        feature3Title: 'Cohérence de Mouvement Haute Dynamique',
        feature3Description: 'Résout le problème des vidéos AI traditionnelles causant l\'effondrement des membres lors de mouvements à grande échelle.',
        feature4Title: 'Cohérence de Style Multi-Plans',
        feature4Description: 'Conçu spécifiquement pour les créateurs de vidéos longues, le modèle peut comprendre et mémoriser des styles artistiques spécifiques.',

        // How to use section
        howToUseTitle: 'Comment Utiliser Dreamina 3.0 sur 微鲤AI',
        step1Title: 'Sélectionner le Modèle',
        step1Description: 'Sélectionnez le modèle Dreamina 3.0 ou Dreamina 3.0 Pro dans les outils vidéo AI',
        step2Title: 'Saisir le Contenu',
        step2Description: 'Entrez un prompt ou téléchargez une image comme "première image"',
        step3Title: 'Générer la Vidéo',
        step3Description: 'Cliquez sur le bouton générer, attendez et téléchargez votre vidéo',

        // YouTube videos section
        youtubeTitle: 'Présentations Vidéo Passionnantes sur Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Publications X Populaires sur Dreamina 3.0',

        // Explore other models section
        exploreModelsTitle: 'Explorez d\'Autres Modèles Vidéo sur 微鲤AI',

        // FAQ section
        faqTitle: 'Questions Fréquentes',
        faq1Question: 'Quelle est la relation entre Dreamina 3.0 et Dreamina?',
        faq1Answer: 'Dreamina est une plateforme créative AI lancée par ByteDance, tandis que Dreamina 3.0 est le modèle de génération vidéo de dernière génération sur cette plateforme.',
        faq2Question: 'Quels sont les usages pratiques du "contrôle images début/fin"?',
        faq2Answer: 'Cela vous permet de contrôler précisément la direction de votre vidéo.',
        faq3Question: 'Quelle est la résolution des vidéos générées?',
        faq3Answer: 'Dreamina 3.0 prend en charge la génération de vidéos en résolution 720P et 1080P.',
        faq4Question: 'Est-ce gratuit sur 微鲤AI?',
        faq4Answer: '微鲤AI fournit des crédits gratuits aux nouveaux utilisateurs pour expérimenter Dreamina 3.0.',
        faq5Question: 'Quelle durée de vidéos peut-il générer?',
        faq5Answer: 'Actuellement, la durée standard de génération unique est de 5 et 10 secondes.',
        faq6Question: 'Peut-il comprendre des prompts chinois complexes?',
        faq6Answer: 'Oui, en tant que modèle développé par ByteDance, Dreamina 3.0 a une compréhension profonde du contexte chinois.',

        // CTA section
        ctaTitle: 'Expérimentez Dreamina 3.0 Maintenant',
        ctaDescription: 'Commencez à créer des vidéos AI cinématographiques gratuitement sur 微鲤AI',
        ctaButton: 'Commencer à Générer des Vidéos',
        ctaDisclaimer: 'Pas de carte de crédit requise, inscrivez-vous pour utiliser',
    },
    de: {
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Videogenerator - Kinematische Kamerasteuerung | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) ist ByteDances Flaggschiff-AI-Videomodell mit präziser Start/Ende-Frame-Steuerung, professionellen kinematischen Kamerabewegungen und 1080P hochdynamischer Videogenerierung.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI Videogenerierung, Frame-Steuerung, kinematische Kamera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Videogenerator',
        generatorDescription: 'Jimeng Video 3.0 ist ByteDances neuestes Flaggschiff-AI-Videomodell, das den Höhepunkt der aktuellen Videogenerierungstechnologie darstellt. Kommen Sie zu 微鲤AI und erleben Sie Dreamina 3.0!',

        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Kernfunktionen',

        // Features
        feature1Title: 'Präzise Start/Ende-Frame-Steuerung',
        feature1Description: 'Dies ist das Killer-Feature von Video 3.0. Benutzer können ein Bild als Videoanfang und ein anderes als Ende hochladen.',
        feature2Title: 'Professionelle Kinematische Kamerabewegung',
        feature2Description: 'Basierend auf der neuen PixelDance-Technologie unterstützt dieses Modell reichhaltige Kamerasprache, einschließlich Zoom, Schwenk, Orbit und Untersicht-Aufnahmen.',
        feature3Title: 'Hochdynamische Bewegungskonsistenz',
        feature3Description: 'Löst das Problem traditioneller AI-Videos, bei denen Gliedmaßen bei groß angelegten Bewegungen zusammenbrechen.',
        feature4Title: 'Multi-Shot-Stil-Konsistenz',
        feature4Description: 'Speziell für Langvideo-Ersteller konzipiert, kann das Modell bestimmte künstlerische Stile verstehen und sich merken.',

        // How to use section
        howToUseTitle: 'So verwenden Sie Dreamina 3.0 auf 微鲤AI',
        step1Title: 'Modell auswählen',
        step1Description: 'Wählen Sie das Dreamina 3.0 oder Dreamina 3.0 Pro Modell in den AI-Video-Tools',
        step2Title: 'Inhalt eingeben',
        step2Description: 'Geben Sie einen Prompt ein oder laden Sie ein Bild als "erstes Frame" hoch',
        step3Title: 'Video generieren',
        step3Description: 'Klicken Sie auf die Generieren-Schaltfläche, warten Sie und laden Sie Ihr Video herunter',

        // YouTube videos section
        youtubeTitle: 'Spannende Video-Einführungen zu Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Beliebte X-Beiträge zu Dreamina 3.0',

        // Explore other models section
        exploreModelsTitle: 'Entdecken Sie andere Videomodelle auf 微鲤AI',

        // FAQ section
        faqTitle: 'Häufig gestellte Fragen',
        faq1Question: 'Was ist die Beziehung zwischen Dreamina 3.0 und Dreamina?',
        faq1Answer: 'Dreamina ist eine AI-Kreativplattform von ByteDance, während Dreamina 3.0 das neueste Videogenerierungsmodell auf dieser Plattform ist.',
        faq2Question: 'Was sind die praktischen Anwendungen der "Start/Ende-Frame-Steuerung"?',
        faq2Answer: 'Sie ermöglicht eine präzise Kontrolle über die Richtung Ihres Videos.',
        faq3Question: 'Welche Auflösung haben die generierten Videos?',
        faq3Answer: 'Dreamina 3.0 unterstützt die Videogenerierung in 720P und 1080P Auflösung.',
        faq4Question: 'Ist es kostenlos auf 微鲤AI?',
        faq4Answer: '微鲤AI bietet neuen Benutzern kostenlose Credits, um Dreamina 3.0 zu erleben.',
        faq5Question: 'Wie lange Videos kann es generieren?',
        faq5Answer: 'Derzeit beträgt die Standard-Einzelgenerierungsdauer 5 und 10 Sekunden.',
        faq6Question: 'Kann es komplexe chinesische Prompts verstehen?',
        faq6Answer: 'Ja, als von ByteDance entwickeltes Modell hat Dreamina 3.0 ein tiefes Verständnis des chinesischen Kontexts.',

        // CTA section
        ctaTitle: 'Erleben Sie Dreamina 3.0 jetzt',
        ctaDescription: 'Beginnen Sie kostenlos kinematische AI-Videos auf 微鲤AI zu erstellen',
        ctaButton: 'Videogenerierung starten',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich, registrieren Sie sich zur Nutzung',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Генератор видео - Кинематографическое управление камерой | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) - флагманская AI модель видео ByteDance с точным контролем начального/конечного кадра, профессиональными кинематографическими движениями камеры и генерацией видео высокой динамики 1080P.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI генерация видео, контроль кадров, кинематографическая камера, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Генератор видео',
        generatorDescription: 'Jimeng Video 3.0 - новейшая флагманская AI модель видео ByteDance, представляющая вершину современной технологии генерации видео. Приходите на 微鲤AI и испытайте Dreamina 3.0!',

        // Tabs
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // Core features section
        coreFeaturesTitle: 'Основные функции Dreamina 3.0',

        // Features
        feature1Title: 'Точный контроль начального/конечного кадра',
        feature1Description: 'Это киллер-функция Video 3.0. Пользователи могут загрузить изображение как начало видео и другое как конец.',
        feature2Title: 'Профессиональное кинематографическое движение камеры',
        feature2Description: 'На основе новой технологии PixelDance эта модель поддерживает богатый язык камеры, включая зум, панораму, орбиту и съёмку с низкого угла.',
        feature3Title: 'Высокодинамичная согласованность движения',
        feature3Description: 'Решает проблему традиционных AI видео с разрушением конечностей при генерации масштабных движений.',
        feature4Title: 'Согласованность стиля мульти-кадра',
        feature4Description: 'Специально разработана для создателей длинных видео, модель может понимать и запоминать определённые художественные стили.',

        // How to use section
        howToUseTitle: 'Как использовать Dreamina 3.0 на 微鲤AI',
        step1Title: 'Выберите модель',
        step1Description: 'Выберите модель Dreamina 3.0 или Dreamina 3.0 Pro в инструментах AI видео',
        step2Title: 'Введите контент',
        step2Description: 'Введите промпт или загрузите изображение как "первый кадр"',
        step3Title: 'Сгенерируйте видео',
        step3Description: 'Нажмите кнопку генерации, подождите и скачайте ваше видео',

        // YouTube videos section
        youtubeTitle: 'Захватывающие видео-презентации о Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Популярные посты X о Dreamina 3.0',

        // Explore other models section
        exploreModelsTitle: 'Исследуйте другие видео модели на 微鲤AI',

        // FAQ section
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Какая связь между Dreamina 3.0 и Dreamina?',
        faq1Answer: 'Dreamina - это AI креативная платформа от ByteDance, а Dreamina 3.0 - новейшая модель генерации видео на этой платформе.',
        faq2Question: 'Каковы практические применения "контроля начального/конечного кадра"?',
        faq2Answer: 'Это позволяет точно контролировать направление вашего видео.',
        faq3Question: 'Какое разрешение у сгенерированных видео?',
        faq3Answer: 'Dreamina 3.0 поддерживает генерацию видео в разрешении 720P и 1080P.',
        faq4Question: 'Это бесплатно на 微鲤AI?',
        faq4Answer: '微鲤AI предоставляет бесплатные кредиты новым пользователям для испытания Dreamina 3.0.',
        faq5Question: 'Какой длины видео можно генерировать?',
        faq5Answer: 'В настоящее время стандартная длительность одной генерации составляет 5 и 10 секунд.',
        faq6Question: 'Может ли понимать сложные китайские промпты?',
        faq6Answer: 'Да, как модель разработанная ByteDance, Dreamina 3.0 глубоко понимает китайский контекст.',

        // CTA section
        ctaTitle: 'Испытайте Dreamina 3.0 сейчас',
        ctaDescription: 'Начните создавать кинематографические AI видео бесплатно на 微鲤AI',
        ctaButton: 'Начать генерацию видео',
        ctaDisclaimer: 'Кредитная карта не требуется, зарегистрируйтесь для использования',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Gerador de Vídeo AI Dreamina 3.0 - Controle de Câmera Cinematográfico | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) é o modelo de vídeo AI principal da ByteDance com controle preciso de quadro inicial/final, movimentos de câmera cinematográficos profissionais e geração de vídeo de alta dinâmica 1080P.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, geração de vídeo AI, controle de quadros, câmera cinematográfica, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Gerador de Vídeo Dreamina 3.0',
        generatorDescription: 'Jimeng Video 3.0 é o mais recente modelo de vídeo AI principal da ByteDance, representando o ápice da tecnologia atual de geração de vídeo. Venha ao 微鲤AI e experimente Dreamina 3.0!',

        // Tabs
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // Core features section
        coreFeaturesTitle: 'Recursos Principais do Dreamina 3.0',

        // Features
        feature1Title: 'Controle Preciso de Quadro Inicial/Final',
        feature1Description: 'Este é o recurso matador do Video 3.0. Os usuários podem fazer upload de uma imagem como início do vídeo e outra como final.',
        feature2Title: 'Movimento de Câmera Cinematográfico Profissional',
        feature2Description: 'Baseado na nova tecnologia PixelDance, este modelo suporta rica linguagem de câmera, incluindo Zoom, Pan, Órbita e tomadas de ângulo baixo.',
        feature3Title: 'Consistência de Movimento de Alta Dinâmica',
        feature3Description: 'Resolve o problema de vídeos AI tradicionais causando colapso de membros ao gerar movimentos em grande escala.',
        feature4Title: 'Consistência de Estilo Multi-Tomada',
        feature4Description: 'Projetado especificamente para criadores de vídeos longos, o modelo pode entender e lembrar estilos artísticos específicos.',

        // How to use section
        howToUseTitle: 'Como Usar Dreamina 3.0 no 微鲤AI',
        step1Title: 'Selecionar Modelo',
        step1Description: 'Selecione o modelo Dreamina 3.0 ou Dreamina 3.0 Pro nas ferramentas de vídeo AI',
        step2Title: 'Inserir Conteúdo',
        step2Description: 'Insira um prompt ou faça upload de uma imagem como "primeiro quadro"',
        step3Title: 'Gerar Vídeo',
        step3Description: 'Clique no botão gerar, aguarde e baixe seu vídeo',

        // YouTube videos section
        youtubeTitle: 'Introduções em Vídeo Emocionantes sobre Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Postagens X Populares sobre Dreamina 3.0',

        // Explore other models section
        exploreModelsTitle: 'Explore Outros Modelos de Vídeo no 微鲤AI',

        // FAQ section
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'Qual é a relação entre Dreamina 3.0 e Dreamina?',
        faq1Answer: 'Dreamina é uma plataforma criativa AI lançada pela ByteDance, enquanto Dreamina 3.0 é o modelo de geração de vídeo de última geração nesta plataforma.',
        faq2Question: 'Quais são os usos práticos do "controle de quadro inicial/final"?',
        faq2Answer: 'Permite controlar com precisão a direção do seu vídeo.',
        faq3Question: 'Qual é a resolução dos vídeos gerados?',
        faq3Answer: 'Dreamina 3.0 suporta geração de vídeo em resolução 720P e 1080P.',
        faq4Question: 'É gratuito no 微鲤AI?',
        faq4Answer: '微鲤AI fornece créditos gratuitos para novos usuários experimentarem Dreamina 3.0.',
        faq5Question: 'Qual duração de vídeos pode gerar?',
        faq5Answer: 'Atualmente, a duração padrão de geração única é de 5 e 10 segundos.',
        faq6Question: 'Pode entender prompts chineses complexos?',
        faq6Answer: 'Sim, como modelo desenvolvido pela ByteDance, Dreamina 3.0 tem uma compreensão profunda do contexto chinês.',

        // CTA section
        ctaTitle: 'Experimente Dreamina 3.0 Agora',
        ctaDescription: 'Comece a criar vídeos AI cinematográficos gratuitamente no 微鲤AI',
        ctaButton: 'Começar a Gerar Vídeos',
        ctaDisclaimer: 'Não é necessário cartão de crédito, registre-se para usar',
    },
    it: {
        // SEO Meta
        pageTitle: 'Generatore di Video AI Dreamina 3.0 - Controllo Telecamera Cinematografico | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) è il modello video AI di punta di ByteDance con controllo preciso del frame iniziale/finale, movimenti telecamera cinematografici professionali e generazione video ad alta dinamica 1080P.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, generazione video AI, controllo frame, telecamera cinematografica, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Generatore di Video Dreamina 3.0',
        generatorDescription: 'Jimeng Video 3.0 è l\'ultimo modello video AI di punta di ByteDance, che rappresenta l\'apice della tecnologia attuale di generazione video. Vieni su 微鲤AI e prova Dreamina 3.0!',

        // Tabs
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // Core features section
        coreFeaturesTitle: 'Funzionalità Principali di Dreamina 3.0',

        // Features
        feature1Title: 'Controllo Preciso Frame Iniziale/Finale',
        feature1Description: 'Questa è la funzionalità killer di Video 3.0. Gli utenti possono caricare un\'immagine come inizio video e un\'altra come fine.',
        feature2Title: 'Movimento Telecamera Cinematografico Professionale',
        feature2Description: 'Basato sulla nuova tecnologia PixelDance, questo modello supporta un ricco linguaggio della telecamera, inclusi Zoom, Pan, Orbita e riprese dal basso.',
        feature3Title: 'Coerenza di Movimento ad Alta Dinamica',
        feature3Description: 'Risolve il problema dei video AI tradizionali che causano il collasso degli arti durante movimenti su larga scala.',
        feature4Title: 'Coerenza di Stile Multi-Inquadratura',
        feature4Description: 'Progettato specificamente per i creatori di video lunghi, il modello può comprendere e ricordare stili artistici specifici.',

        // How to use section
        howToUseTitle: 'Come Usare Dreamina 3.0 su 微鲤AI',
        step1Title: 'Seleziona Modello',
        step1Description: 'Seleziona il modello Dreamina 3.0 o Dreamina 3.0 Pro negli strumenti video AI',
        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci un prompt o carica un\'immagine come "primo frame"',
        step3Title: 'Genera Video',
        step3Description: 'Clicca sul pulsante genera, attendi e scarica il tuo video',

        // YouTube videos section
        youtubeTitle: 'Emozionanti Introduzioni Video su Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Post X Popolari su Dreamina 3.0',

        // Explore other models section
        exploreModelsTitle: 'Esplora Altri Modelli Video su 微鲤AI',

        // FAQ section
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Qual è la relazione tra Dreamina 3.0 e Dreamina?',
        faq1Answer: 'Dreamina è una piattaforma creativa AI lanciata da ByteDance, mentre Dreamina 3.0 è il modello di generazione video di ultima generazione su questa piattaforma.',
        faq2Question: 'Quali sono gli usi pratici del "controllo frame iniziale/finale"?',
        faq2Answer: 'Ti permette di controllare con precisione la direzione del tuo video.',
        faq3Question: 'Qual è la risoluzione dei video generati?',
        faq3Answer: 'Dreamina 3.0 supporta la generazione video in risoluzione 720P e 1080P.',
        faq4Question: 'È gratuito su 微鲤AI?',
        faq4Answer: '微鲤AI fornisce crediti gratuiti ai nuovi utenti per provare Dreamina 3.0.',
        faq5Question: 'Quanto lunghi possono essere i video generati?',
        faq5Answer: 'Attualmente, la durata standard di singola generazione è di 5 e 10 secondi.',
        faq6Question: 'Può comprendere prompt cinesi complessi?',
        faq6Answer: 'Sì, come modello sviluppato da ByteDance, Dreamina 3.0 ha una profonda comprensione del contesto cinese.',

        // CTA section
        ctaTitle: 'Prova Dreamina 3.0 Ora',
        ctaDescription: 'Inizia a creare video AI cinematografici gratuitamente su 微鲤AI',
        ctaButton: 'Inizia a Generare Video',
        ctaDisclaimer: 'Nessuna carta di credito richiesta, registrati per usare',
    },
    ar: {
        // SEO Meta
        pageTitle: 'مولد فيديو Dreamina 3.0 AI - تحكم كاميرا سينمائي | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) هو نموذج فيديو AI الرائد من ByteDance مع تحكم دقيق في الإطار البداية/النهاية، وحركات كاميرا سينمائية احترافية، وتوليد فيديو عالي الديناميكية 1080P.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, توليد فيديو AI, تحكم الإطار, كاميرا سينمائية, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'مولد فيديو Dreamina 3.0',
        generatorDescription: 'Jimeng Video 3.0 هو أحدث نموذج فيديو AI الرائد من ByteDance، يمثل قمة تقنية توليد الفيديو الحالية. تعال إلى 微鲤AI وجرب Dreamina 3.0!',

        // Tabs
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // Core features section
        coreFeaturesTitle: 'الميزات الرئيسية لـ Dreamina 3.0',

        // Features
        feature1Title: 'تحكم دقيق في إطار البداية/النهاية',
        feature1Description: 'هذه هي الميزة القاتلة لـ Video 3.0. يمكن للمستخدمين تحميل صورة كبداية للفيديو وأخرى كنهاية.',
        feature2Title: 'حركة كاميرا سينمائية احترافية',
        feature2Description: 'استنادًا إلى تقنية PixelDance الجديدة، يدعم هذا النموذج لغة كاميرا غنية، بما في ذلك التكبير والتحريك والدوران واللقطات منخفضة الزاوية.',
        feature3Title: 'اتساق حركة عالي الديناميكية',
        feature3Description: 'يحل مشكلة فيديوهات AI التقليدية التي تسبب انهيار الأطراف عند توليد حركات واسعة النطاق.',
        feature4Title: 'اتساق أسلوب متعدد اللقطات',
        feature4Description: 'مصمم خصيصًا لمنشئي الفيديو الطويل، يمكن للنموذج فهم وتذكر الأنماط الفنية المحددة.',

        // How to use section
        howToUseTitle: 'كيفية استخدام Dreamina 3.0 على 微鲤AI',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Dreamina 3.0 أو Dreamina 3.0 Pro في أدوات الفيديو AI',
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل موجهًا أو قم بتحميل صورة كـ "الإطار الأول"',
        step3Title: 'توليد الفيديو',
        step3Description: 'انقر على زر التوليد، انتظر وقم بتنزيل الفيديو الخاص بك',

        // YouTube videos section
        youtubeTitle: 'مقدمات فيديو مثيرة عن Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'منشورات X الشائعة عن Dreamina 3.0',

        // Explore other models section
        exploreModelsTitle: 'استكشف نماذج الفيديو الأخرى على 微鲤AI',

        // FAQ section
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هي العلاقة بين Dreamina 3.0 و Dreamina؟',
        faq1Answer: 'Dreamina هي منصة إبداعية AI أطلقتها ByteDance، بينما Dreamina 3.0 هو نموذج توليد الفيديو من الجيل الأحدث على هذه المنصة.',
        faq2Question: 'ما هي الاستخدامات العملية لـ "تحكم إطار البداية/النهاية"؟',
        faq2Answer: 'يتيح لك التحكم بدقة في اتجاه الفيديو الخاص بك.',
        faq3Question: 'ما هي دقة الفيديوهات المولدة؟',
        faq3Answer: 'يدعم Dreamina 3.0 توليد الفيديو بدقة 720P و 1080P.',
        faq4Question: 'هل هو مجاني على 微鲤AI؟',
        faq4Answer: 'يوفر 微鲤AI رصيدًا مجانيًا للمستخدمين الجدد لتجربة Dreamina 3.0.',
        faq5Question: 'ما طول الفيديوهات التي يمكن توليدها؟',
        faq5Answer: 'حاليًا، مدة التوليد الفردي القياسية هي 5 و 10 ثوانٍ.',
        faq6Question: 'هل يمكنه فهم الموجهات الصينية المعقدة؟',
        faq6Answer: 'نعم، كنموذج طورته ByteDance، يتمتع Dreamina 3.0 بفهم عميق للسياق الصيني.',

        // CTA section
        ctaTitle: 'جرب Dreamina 3.0 الآن',
        ctaDescription: 'ابدأ في إنشاء فيديوهات AI سينمائية مجانًا على 微鲤AI',
        ctaButton: 'بدء توليد الفيديوهات',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان، سجل للاستخدام',
        },
    th: { // Thai (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
        },
    da: { // Danish (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
        },
    no: { // Norwegian (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
        },
    nl: { // Dutch (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
        },
    id: { // Indonesian (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
        },
    tr: { // Turkish (copied from English)
        // SEO Meta
        pageTitle: 'Dreamina 3.0 AI Video Generator - Cinematic Video with Camera Control | 微鲤AI',
        pageDescription: 'Dreamina 3.0 (Jimeng 3.0) is ByteDance\'s flagship AI video model featuring precise start/end frame control, professional cinematic camera movements, and 1080P high-dynamic video generation. Experience Dreamina 3.0 for free on 微鲤AI.',
        pageKeywords: 'Dreamina 3.0, Jimeng 3.0, AI video generation, start end frame control, cinematic camera, ByteDance, 微鲤AI',

        // Generator section
        generatorTitle: 'Dreamina 3.0 Video Generator',
        generatorDescription: 'Jimeng Video 3.0 is ByteDance\'s latest flagship AI video model, representing the pinnacle of current video generation technology. As a core upgrade to the Dreamina creative suite, this model introduces revolutionary "start/end frame control" technology and a professional cinematic camera system, capable of generating high-dynamic videos up to 1080P resolution. It significantly improves the stability of large-scale movements and enables creators to easily control complex narrative rhythms through precise physics simulation. Come to 微鲤AI and experience Dreamina 3.0 - direct your visual masterpiece with just an image or text!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Dreamina 3.0 Core Features',

        // Features
        feature1Title: 'Precise Start/End Frame Control',
        feature1Description: 'This is the killer feature of Video 3.0. Users can not only upload an image as the video\'s start (first frame), but also upload another image as the end (last frame). The model automatically calculates the transition animation in between, ensuring the video perfectly evolves from one state to another. This is crucial for creating transformation effects, time-lapse, or precise transition shots.',
        feature2Title: 'Professional Cinematic Camera Movement',
        feature2Description: 'Based on the new PixelDance underlying technology, this model supports rich camera language, including Zoom, Pan, Orbit, and low-angle shots. Compared to previous generations, its camera movements are smoother and more natural, capable of simulating the handheld feel of real cinematographers or track shooting effects, greatly enhancing video immersion.',
        feature3Title: 'High-Dynamic Motion Consistency',
        feature3Description: 'Solves the problem of traditional AI videos causing character limb collapse when generating large-scale movements (such as dancing, running, fighting). Jimeng Video 3.0 enhances understanding of human skeletal structure and physical motion laws, maintaining stable and unified character facial and limb features even during intense movements.',
        feature4Title: 'Multi-Shot Style Consistency',
        feature4Description: 'Designed specifically for long-video creators, the model can understand and remember specific artistic styles. When generating a series of storyboards, it ensures that lighting tones, character designs, and environmental atmosphere remain highly consistent across different shots - extending an entire short film\'s visual materials from just one reference image.',

        // How to use section
        howToUseTitle: 'How to Use Dreamina 3.0 Video Generator on 微鲤AI',
        step1Title: 'Select Model',
        step1Description: 'Select the Dreamina 3.0 or Dreamina 3.0 Pro model in AI video tools',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload an image as the "first frame"',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Dreamina 3.0',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Dreamina 3.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on 微鲤AI',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is the relationship between Dreamina 3.0 video model and Dreamina?',
        faq1Answer: 'Dreamina is an AI creative platform launched by ByteDance (known as "Jimeng" in China), while Dreamina 3.0 video model is the latest generation video generation model on this platform. On 微鲤AI, we directly provide you access to this core model capability.',
        faq2Question: 'What are the practical uses of "start/end frame control"?',
        faq2Answer: 'It allows you to precisely control the direction of your video. For example, you can upload a "closed eyes" image as the first frame and an "open eyes" image as the last frame, and the model will generate a natural eye-opening process. This is very useful for creating specific plots or smooth transitions.',
        faq3Question: 'What is the resolution of generated videos?',
        faq3Answer: 'Dreamina 3.0 video model supports generating videos at 720P and 1080P resolution, with extremely high clarity and texture details, sufficient for social media publishing and even some commercial advertising needs.',
        faq4Question: 'Is it free to use on 微鲤AI?',
        faq4Answer: '微鲤AI provides free credits for new users, which you can use to experience Dreamina 3.0 video model. Since video generation requires significant computing power, generating once may consume more credits than images. We recommend upgrading membership for more creation quota.',
        faq5Question: 'How long videos can it generate?',
        faq5Answer: 'Currently, standard single generation duration is 5 seconds and 10 seconds. But you can use the "Extend Video" feature to continue extending based on the generated video, achieving longer clips.',
        faq6Question: 'Can it understand complex Chinese prompts?',
        faq6Answer: 'Yes, as a model developed by ByteDance, Dreamina 3.0 video model has a deep understanding of Chinese context, capable of accurately reproducing idioms, classical poetry imagery, and complex Eastern aesthetic descriptions.',

        // CTA section
        ctaTitle: 'Experience Dreamina 3.0 Now',
        ctaDescription: 'Start creating cinematic AI videos for free on 微鲤AI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
    },
}
